@if (shouldShow$ | async) {
  <div
    class="fixed inset-0 flex items-center justify-center z-999 bg-gray-700 bg-opacity-50 transition-all duration-300 ease-in-out"
    [class.opacity-100]="isLoading$ | async"
    [class.opacity-0]="!(isLoading$ | async)"
    [class.pointer-events-none]="!(isLoading$ | async)"
    >
    <div class="transform transition-transform duration-300 ease-in-out"
      [class.scale-100]="isLoading$ | async"
      [class.scale-95]="!(isLoading$ | async)">
      <lib-page-spinner size="large" [color]="themeColor"></lib-page-spinner>
    </div>
  </div>
}